import clsx from "clsx";
import "./filters.scss";
import { DocumentedComponent } from "./DocumentedComponent";
import { getDataProps } from "../../shared/utilities";

interface FilterRowProps {
    name?: string;
    className?: string;
    children?: any;
}

function FilterRow(props: FilterRowProps) {
    const { className, children, ...rest } = props;

    return (
        <div className={clsx("canvas-filter-row", className)} {...rest} {...getDataProps(props)}>
            {children}
        </div>
    );
}

(FilterRow as DocumentedComponent).metadata = {
    description: "The `FilterRow` component is used to display a row of filters.  It contains one or more `Filter` components as children.",
    isSelfClosing: false,
    attributes: [
        { name: `name`, type: `string`, description: "If provided, the underlying component's `data-testid` attribute will be set to this value. This is useful for targeting the element via Playwright, Puppeteer or similar UI testing tools. Can be overridden via an explicit `data-testid` value. Optional - no default value." },
    ]
};

interface FilterProps {
    name?: string;
    title?: string;
    className?: string;
    children?: any;
}

function Filter(props: FilterProps) {
    const { title, children, className, ...rest } = props;

    return (
        <div className={clsx("canvas-filter", className)} {...rest} {...getDataProps(props)}>
            <span className="filter-title">{title}</span>
            <div className="controls-list">
                {children}
            </div>
        </div>
    );
}

(Filter as DocumentedComponent).metadata = {
    description: "The `Filter` component serves as a container for a single input component.  It is adorned with an (optional) label.",
    isSelfClosing: false,
    attributes: [
        { name: `name`, type: `string`, description: "If provided, the underlying component's `data-testid` attribute will be set to this value. This is useful for targeting the element via Playwright, Puppeteer or similar UI testing tools. Can be overridden via an explicit `data-testid` value. Optional - no default value." },
        { name: `title`, type: `string`, description: "The text to display in the filter's label." }
    ]
};

export { FilterRow, Filter };